<template>
  <section class="search-sidebar__content">
    <fieldset class="fieldset">
      <legend class="fieldset__label">Выбранные классификаторы</legend>

      <button
        v-if="sessionStatus !== 'classifiers'"
        class="button _left-icon"
        @click="onReturnButtonClick"
      >
        <svg width="16" height="16">
          <use xlink:href="#arrow-sides"></use>
        </svg>
        Вернуться к поисковому фильтру
      </button>

      <div
        v-if="selectedClassifiers.length"
        class="search-filter__selected-items"
      >
        <span
          v-for="(item, index) in selectedClassifiers"
          :key="item.id"
          class="search-filter__selected-item"
        >
          {{ item.title }}
          <span
            class="search-filter__selected-item-delete"
            @click="deleteItem(index)"
          >
            &times;
          </span>
        </span>
      </div>

      <div v-else class="form__prompt">Нет выбранных классификаторов</div>
    </fieldset>

    <div v-if="classifiers.length" class="classifiers__bases-list">
      <search-classifiers-base
        v-for="classifier in classifiers"
        :key="classifier.id"
        :classifier="classifier"
      />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

import SearchClassifiersBase from './SearchClassifiersBase';

export default {
  components: {
    SearchClassifiersBase
  },

  computed: {
    ...mapGetters({
      classifiers: 'classifiersList',
      selectedClassifiers: 'selectedClassifiers',
      sessionStatus: 'searchSessionStatus'
    })
  },

  async created() {
    await this.$store.dispatch('getClassifiersList');
  },

  methods: {
    deleteItem(ind) {
      this.$store.dispatch('changeClassifiersQuery', {
        selected: true,
        classifier: this.selectedClassifiers[ind]
      });
    },
    onReturnButtonClick() {
      this.$emit('return');
    }
  }
};
</script>
